export const SITUACAO_INTERVENCAO_OXY = {
  ANDAMENTO: 'Em Andamento',
  PARALISADO: 'Paralisada',
  CONCLUIDO: 'Concluída',
  CANCELADO: 'Cancelada',
  CADASTRO_INDEVIDO: 'Indevido',
  RESCINDIDA: 'Rescindida',
  NAO_INICIADA: 'Não Iniciada'
};

export const DEFAULT_SITUACOES = [
  'ANDAMENTO',
  'PARALISADO',
  'CADASTRO_INDEVIDO',
  'RESCINDIDA',
  'NAO_INICIADA'
];

const COR_POR_SITUACAO = {
  ANDAMENTO: '#4a4aff',
  PARALISADO: '#ff7f00',
  NAO_INICIADA: '#646464',
  CONCLUIDO: 'var(--primary)',
  CANCELADO: 'var(--negative)',
  RESCINDIDA: '#7f00ff',
  CADASTRO_INDEVIDO: '#ff00ff',
  FALLBACK: '#607D8B'
};

export function corPorSituacao(situacao) {
  return (situacao && COR_POR_SITUACAO[situacao]) || COR_POR_SITUACAO.FALLBACK;
}
